import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import type GradescheduleRange from '@linc-technologies/linced-common/models/assessments/gradeschedule-range';

// Proto: assessments.GradeScheduleNumeric.
export default class GradescheduleNumeric extends Fragment {
  declare [Type]: 'assessments/gradeschedule-numeric';

  @fragment('assessments/gradeschedule-range')
  declare range: GradescheduleRange | null;

  @attr('number', { defaultValue: 1 })
  declare defaultNumericStepping: number;
}
